import { render, staticRenderFns } from "./InterviewInvitationModal.vue?vue&type=template&id=37976a79"
import script from "./InterviewInvitationModal.vue?vue&type=script&lang=js"
export * from "./InterviewInvitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports